import { createElement, cloneElement, Fragment } from 'react';
import { string, oneOfType, element, func, bool } from 'prop-types';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import InlineBlock from 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import Pane from './Pane/index.js';
import { a as isFunction } from './chunk-5c9bbccf.js';
import PopoverContainer from './Popover/PopoverContainer.js';
import PopoverHide from './Popover/PopoverHide.js';
import PopoverClose from './Popover/PopoverClose.js';
import PopoverPopover, { popoverPopoverPropTypes, popoverPopoverDefaultProps } from './Popover/PopoverPopover.js';
import PopoverShow from './Popover/PopoverShow.js';
import PopoverToggle from './Popover/PopoverToggle.js';

var Popover = function Popover(_ref) {
  var children = _ref.children,
      content = _ref.content,
      isFullWidth = _ref.isFullWidth,
      showCloseButton = _ref.showCloseButton,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "content", "isFullWidth", "showCloseButton"]);

  return createElement(PopoverContainer, null, function (popover) {
    return createElement(InlineBlock, {
      relative: true,
      width: isFullWidth ? '100%' : undefined
    }, isFunction(children) ?
    /*
    // @ts-ignore */
    children(_objectSpread({
      use: PopoverToggle
    }, popover)) : children ? cloneElement(children, _objectSpread({
      use: PopoverToggle
    }, popover)) : null, popover.isVisible && createElement(PopoverPopover, _extends({
      elevation: "200"
    }, props, popover, {
      use: Pane
    }), function (_ref2) {
      var initialFocusRef = _ref2.initialFocusRef;
      return createElement(Fragment, null, showCloseButton && createElement(PopoverClose, _extends({
        elementRef: initialFocusRef
      }, popover)), typeof content === 'function' ? content(_objectSpread({
        initialFocusRef: initialFocusRef
      }, popover)) : content);
    }));
  });
};

Popover.Popover = PopoverPopover;
Popover.Container = PopoverContainer;
Popover.Close = PopoverClose;
Popover.Hide = PopoverHide;
Popover.Show = PopoverShow;
Popover.Toggle = PopoverToggle;

var popoverPropTypes = _objectSpread({}, popoverPopoverPropTypes, {
  className: string,
  children: oneOfType([element, func]).isRequired,
  content: oneOfType([string, element, func]),
  isFullWidth: bool,
  showCloseButton: bool
});

var popoverDefaultProps = _objectSpread({}, popoverPopoverDefaultProps, {
  children: undefined,
  className: undefined,
  isFullWidth: false,
  showCloseButton: false
});

Popover.defaultProps = popoverDefaultProps; // @ts-ignore

var C = Popover;
export { popoverPropTypes as a, C as b, popoverDefaultProps as c };